import { useEffect, useState } from 'react';
import { aiAPI } from '../lib/api';

let cache = null;
let cacheKey = null;
let inflight = null;
export default function useAIStatus() {
  const token = localStorage.getItem('token');
  const valid = cache && cacheKey === token;
  const [status, setStatus] = useState(valid ? cache : { enabled: false, functions: {} });
  useEffect(() => {
    if (cache && cacheKey === token) return;
    cache = null;
    if (!inflight) {
      inflight = aiAPI.status().then((r) => {
        cache = r.data; cacheKey = token;
        return r.data;
      }).finally(() => { inflight = null; });
    }
    inflight.then((d) => setStatus(d)).catch(() => {});
  }, [token]);
  return status;
}
